module.exports = __webpack_public_path__ + "img/screen2.60160bc2.jpeg";